export interface Country {
  code: string;
  name: string;
  callingCode: string;
  phoneMin: number;
  phoneMax: number;
}

export const COUNTRIES: Country[] = [
  { code: "US", name: "United States", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "CA", name: "Canada", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "GB", name: "United Kingdom", callingCode: "44", phoneMin: 10, phoneMax: 10 },
  { code: "AF", name: "Afghanistan", callingCode: "93", phoneMin: 9, phoneMax: 9 },
  { code: "AL", name: "Albania", callingCode: "355", phoneMin: 8, phoneMax: 9 },
  { code: "DZ", name: "Algeria", callingCode: "213", phoneMin: 8, phoneMax: 9 },
  { code: "AS", name: "American Samoa", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "AD", name: "Andorra", callingCode: "376", phoneMin: 6, phoneMax: 9 },
  { code: "AO", name: "Angola", callingCode: "244", phoneMin: 9, phoneMax: 9 },
  { code: "AI", name: "Anguilla", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "AG", name: "Antigua and Barbuda", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "AR", name: "Argentina", callingCode: "54", phoneMin: 10, phoneMax: 11 },
  { code: "AM", name: "Armenia", callingCode: "374", phoneMin: 8, phoneMax: 8 },
  { code: "AW", name: "Aruba", callingCode: "297", phoneMin: 7, phoneMax: 7 },
  { code: "AU", name: "Australia", callingCode: "61", phoneMin: 9, phoneMax: 9 },
  { code: "AT", name: "Austria", callingCode: "43", phoneMin: 10, phoneMax: 13 },
  { code: "AZ", name: "Azerbaijan", callingCode: "994", phoneMin: 9, phoneMax: 9 },
  { code: "BS", name: "Bahamas", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "BH", name: "Bahrain", callingCode: "973", phoneMin: 8, phoneMax: 8 },
  { code: "BD", name: "Bangladesh", callingCode: "880", phoneMin: 10, phoneMax: 10 },
  { code: "BB", name: "Barbados", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "BY", name: "Belarus", callingCode: "375", phoneMin: 9, phoneMax: 9 },
  { code: "BE", name: "Belgium", callingCode: "32", phoneMin: 8, phoneMax: 9 },
  { code: "BZ", name: "Belize", callingCode: "501", phoneMin: 7, phoneMax: 7 },
  { code: "BJ", name: "Benin", callingCode: "229", phoneMin: 8, phoneMax: 8 },
  { code: "BM", name: "Bermuda", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "BT", name: "Bhutan", callingCode: "975", phoneMin: 7, phoneMax: 8 },
  { code: "BO", name: "Bolivia", callingCode: "591", phoneMin: 8, phoneMax: 8 },
  { code: "BA", name: "Bosnia and Herzegovina", callingCode: "387", phoneMin: 8, phoneMax: 8 },
  { code: "BW", name: "Botswana", callingCode: "267", phoneMin: 7, phoneMax: 8 },
  { code: "BR", name: "Brazil", callingCode: "55", phoneMin: 10, phoneMax: 11 },
  { code: "BN", name: "Brunei", callingCode: "673", phoneMin: 7, phoneMax: 7 },
  { code: "BG", name: "Bulgaria", callingCode: "359", phoneMin: 8, phoneMax: 9 },
  { code: "BF", name: "Burkina Faso", callingCode: "226", phoneMin: 8, phoneMax: 8 },
  { code: "BI", name: "Burundi", callingCode: "257", phoneMin: 8, phoneMax: 8 },
  { code: "KH", name: "Cambodia", callingCode: "855", phoneMin: 8, phoneMax: 9 },
  { code: "CM", name: "Cameroon", callingCode: "237", phoneMin: 8, phoneMax: 9 },
  { code: "CV", name: "Cape Verde", callingCode: "238", phoneMin: 7, phoneMax: 7 },
  { code: "KY", name: "Cayman Islands", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "CF", name: "Central African Republic", callingCode: "236", phoneMin: 8, phoneMax: 8 },
  { code: "TD", name: "Chad", callingCode: "235", phoneMin: 8, phoneMax: 8 },
  { code: "CL", name: "Chile", callingCode: "56", phoneMin: 8, phoneMax: 9 },
  { code: "CN", name: "China", callingCode: "86", phoneMin: 11, phoneMax: 11 },
  { code: "CO", name: "Colombia", callingCode: "57", phoneMin: 10, phoneMax: 10 },
  { code: "KM", name: "Comoros", callingCode: "269", phoneMin: 7, phoneMax: 7 },
  { code: "CG", name: "Congo", callingCode: "242", phoneMin: 9, phoneMax: 9 },
  { code: "CD", name: "Congo (DRC)", callingCode: "243", phoneMin: 9, phoneMax: 9 },
  { code: "CK", name: "Cook Islands", callingCode: "682", phoneMin: 5, phoneMax: 5 },
  { code: "CR", name: "Costa Rica", callingCode: "506", phoneMin: 8, phoneMax: 8 },
  { code: "CI", name: "Côte d'Ivoire", callingCode: "225", phoneMin: 8, phoneMax: 10 },
  { code: "HR", name: "Croatia", callingCode: "385", phoneMin: 8, phoneMax: 9 },
  { code: "CU", name: "Cuba", callingCode: "53", phoneMin: 8, phoneMax: 8 },
  { code: "CY", name: "Cyprus", callingCode: "357", phoneMin: 8, phoneMax: 8 },
  { code: "CZ", name: "Czech Republic", callingCode: "420", phoneMin: 9, phoneMax: 9 },
  { code: "DK", name: "Denmark", callingCode: "45", phoneMin: 8, phoneMax: 8 },
  { code: "DJ", name: "Djibouti", callingCode: "253", phoneMin: 8, phoneMax: 8 },
  { code: "DM", name: "Dominica", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "DO", name: "Dominican Republic", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "EC", name: "Ecuador", callingCode: "593", phoneMin: 8, phoneMax: 9 },
  { code: "EG", name: "Egypt", callingCode: "20", phoneMin: 9, phoneMax: 10 },
  { code: "SV", name: "El Salvador", callingCode: "503", phoneMin: 8, phoneMax: 8 },
  { code: "GQ", name: "Equatorial Guinea", callingCode: "240", phoneMin: 9, phoneMax: 9 },
  { code: "ER", name: "Eritrea", callingCode: "291", phoneMin: 7, phoneMax: 7 },
  { code: "EE", name: "Estonia", callingCode: "372", phoneMin: 7, phoneMax: 8 },
  { code: "ET", name: "Ethiopia", callingCode: "251", phoneMin: 9, phoneMax: 9 },
  { code: "FO", name: "Faroe Islands", callingCode: "298", phoneMin: 6, phoneMax: 6 },
  { code: "FJ", name: "Fiji", callingCode: "679", phoneMin: 7, phoneMax: 7 },
  { code: "FI", name: "Finland", callingCode: "358", phoneMin: 9, phoneMax: 10 },
  { code: "FR", name: "France", callingCode: "33", phoneMin: 9, phoneMax: 9 },
  { code: "GF", name: "French Guiana", callingCode: "594", phoneMin: 9, phoneMax: 9 },
  { code: "PF", name: "French Polynesia", callingCode: "689", phoneMin: 8, phoneMax: 8 },
  { code: "GA", name: "Gabon", callingCode: "241", phoneMin: 7, phoneMax: 8 },
  { code: "GM", name: "Gambia", callingCode: "220", phoneMin: 7, phoneMax: 7 },
  { code: "GE", name: "Georgia", callingCode: "995", phoneMin: 9, phoneMax: 9 },
  { code: "DE", name: "Germany", callingCode: "49", phoneMin: 10, phoneMax: 11 },
  { code: "GH", name: "Ghana", callingCode: "233", phoneMin: 9, phoneMax: 9 },
  { code: "GI", name: "Gibraltar", callingCode: "350", phoneMin: 8, phoneMax: 8 },
  { code: "GR", name: "Greece", callingCode: "30", phoneMin: 10, phoneMax: 10 },
  { code: "GL", name: "Greenland", callingCode: "299", phoneMin: 6, phoneMax: 6 },
  { code: "GD", name: "Grenada", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "GP", name: "Guadeloupe", callingCode: "590", phoneMin: 9, phoneMax: 9 },
  { code: "GU", name: "Guam", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "GT", name: "Guatemala", callingCode: "502", phoneMin: 8, phoneMax: 8 },
  { code: "GN", name: "Guinea", callingCode: "224", phoneMin: 8, phoneMax: 9 },
  { code: "GW", name: "Guinea-Bissau", callingCode: "245", phoneMin: 7, phoneMax: 7 },
  { code: "GY", name: "Guyana", callingCode: "592", phoneMin: 7, phoneMax: 7 },
  { code: "HT", name: "Haiti", callingCode: "509", phoneMin: 8, phoneMax: 8 },
  { code: "HN", name: "Honduras", callingCode: "504", phoneMin: 8, phoneMax: 8 },
  { code: "HK", name: "Hong Kong", callingCode: "852", phoneMin: 8, phoneMax: 8 },
  { code: "HU", name: "Hungary", callingCode: "36", phoneMin: 8, phoneMax: 9 },
  { code: "IS", name: "Iceland", callingCode: "354", phoneMin: 7, phoneMax: 9 },
  { code: "IN", name: "India", callingCode: "91", phoneMin: 10, phoneMax: 10 },
  { code: "ID", name: "Indonesia", callingCode: "62", phoneMin: 9, phoneMax: 12 },
  { code: "IR", name: "Iran", callingCode: "98", phoneMin: 10, phoneMax: 10 },
  { code: "IQ", name: "Iraq", callingCode: "964", phoneMin: 10, phoneMax: 10 },
  { code: "IE", name: "Ireland", callingCode: "353", phoneMin: 9, phoneMax: 11 },
  { code: "IL", name: "Israel", callingCode: "972", phoneMin: 9, phoneMax: 9 },
  { code: "IT", name: "Italy", callingCode: "39", phoneMin: 9, phoneMax: 11 },
  { code: "JM", name: "Jamaica", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "JP", name: "Japan", callingCode: "81", phoneMin: 10, phoneMax: 11 },
  { code: "JO", name: "Jordan", callingCode: "962", phoneMin: 9, phoneMax: 9 },
  { code: "KZ", name: "Kazakhstan", callingCode: "7", phoneMin: 10, phoneMax: 10 },
  { code: "KE", name: "Kenya", callingCode: "254", phoneMin: 9, phoneMax: 10 },
  { code: "KI", name: "Kiribati", callingCode: "686", phoneMin: 5, phoneMax: 8 },
  { code: "KW", name: "Kuwait", callingCode: "965", phoneMin: 8, phoneMax: 8 },
  { code: "KG", name: "Kyrgyzstan", callingCode: "996", phoneMin: 9, phoneMax: 9 },
  { code: "LA", name: "Laos", callingCode: "856", phoneMin: 8, phoneMax: 10 },
  { code: "LV", name: "Latvia", callingCode: "371", phoneMin: 8, phoneMax: 8 },
  { code: "LB", name: "Lebanon", callingCode: "961", phoneMin: 7, phoneMax: 8 },
  { code: "LS", name: "Lesotho", callingCode: "266", phoneMin: 8, phoneMax: 8 },
  { code: "LR", name: "Liberia", callingCode: "231", phoneMin: 7, phoneMax: 8 },
  { code: "LY", name: "Libya", callingCode: "218", phoneMin: 9, phoneMax: 10 },
  { code: "LI", name: "Liechtenstein", callingCode: "423", phoneMin: 7, phoneMax: 9 },
  { code: "LT", name: "Lithuania", callingCode: "370", phoneMin: 8, phoneMax: 8 },
  { code: "LU", name: "Luxembourg", callingCode: "352", phoneMin: 4, phoneMax: 11 },
  { code: "MO", name: "Macao", callingCode: "853", phoneMin: 8, phoneMax: 8 },
  { code: "MG", name: "Madagascar", callingCode: "261", phoneMin: 9, phoneMax: 10 },
  { code: "MW", name: "Malawi", callingCode: "265", phoneMin: 7, phoneMax: 9 },
  { code: "MY", name: "Malaysia", callingCode: "60", phoneMin: 9, phoneMax: 10 },
  { code: "MV", name: "Maldives", callingCode: "960", phoneMin: 7, phoneMax: 7 },
  { code: "ML", name: "Mali", callingCode: "223", phoneMin: 8, phoneMax: 8 },
  { code: "MT", name: "Malta", callingCode: "356", phoneMin: 8, phoneMax: 8 },
  { code: "MH", name: "Marshall Islands", callingCode: "692", phoneMin: 7, phoneMax: 7 },
  { code: "MQ", name: "Martinique", callingCode: "596", phoneMin: 9, phoneMax: 9 },
  { code: "MR", name: "Mauritania", callingCode: "222", phoneMin: 8, phoneMax: 8 },
  { code: "MU", name: "Mauritius", callingCode: "230", phoneMin: 7, phoneMax: 8 },
  { code: "MX", name: "Mexico", callingCode: "52", phoneMin: 10, phoneMax: 10 },
  { code: "FM", name: "Micronesia", callingCode: "691", phoneMin: 7, phoneMax: 7 },
  { code: "MD", name: "Moldova", callingCode: "373", phoneMin: 8, phoneMax: 8 },
  { code: "MC", name: "Monaco", callingCode: "377", phoneMin: 8, phoneMax: 9 },
  { code: "MN", name: "Mongolia", callingCode: "976", phoneMin: 8, phoneMax: 8 },
  { code: "ME", name: "Montenegro", callingCode: "382", phoneMin: 8, phoneMax: 12 },
  { code: "MS", name: "Montserrat", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "MA", name: "Morocco", callingCode: "212", phoneMin: 9, phoneMax: 9 },
  { code: "MZ", name: "Mozambique", callingCode: "258", phoneMin: 8, phoneMax: 9 },
  { code: "MM", name: "Myanmar", callingCode: "95", phoneMin: 8, phoneMax: 10 },
  { code: "NA", name: "Namibia", callingCode: "264", phoneMin: 7, phoneMax: 10 },
  { code: "NR", name: "Nauru", callingCode: "674", phoneMin: 7, phoneMax: 7 },
  { code: "NP", name: "Nepal", callingCode: "977", phoneMin: 10, phoneMax: 10 },
  { code: "NL", name: "Netherlands", callingCode: "31", phoneMin: 9, phoneMax: 9 },
  { code: "NC", name: "New Caledonia", callingCode: "687", phoneMin: 6, phoneMax: 6 },
  { code: "NZ", name: "New Zealand", callingCode: "64", phoneMin: 8, phoneMax: 10 },
  { code: "NI", name: "Nicaragua", callingCode: "505", phoneMin: 8, phoneMax: 8 },
  { code: "NE", name: "Niger", callingCode: "227", phoneMin: 8, phoneMax: 8 },
  { code: "NG", name: "Nigeria", callingCode: "234", phoneMin: 7, phoneMax: 10 },
  { code: "MK", name: "North Macedonia", callingCode: "389", phoneMin: 8, phoneMax: 8 },
  { code: "NO", name: "Norway", callingCode: "47", phoneMin: 8, phoneMax: 8 },
  { code: "OM", name: "Oman", callingCode: "968", phoneMin: 8, phoneMax: 8 },
  { code: "PK", name: "Pakistan", callingCode: "92", phoneMin: 10, phoneMax: 10 },
  { code: "PW", name: "Palau", callingCode: "680", phoneMin: 7, phoneMax: 7 },
  { code: "PS", name: "Palestine", callingCode: "970", phoneMin: 9, phoneMax: 9 },
  { code: "PA", name: "Panama", callingCode: "507", phoneMin: 7, phoneMax: 8 },
  { code: "PG", name: "Papua New Guinea", callingCode: "675", phoneMin: 7, phoneMax: 8 },
  { code: "PY", name: "Paraguay", callingCode: "595", phoneMin: 9, phoneMax: 9 },
  { code: "PE", name: "Peru", callingCode: "51", phoneMin: 9, phoneMax: 9 },
  { code: "PH", name: "Philippines", callingCode: "63", phoneMin: 10, phoneMax: 10 },
  { code: "PL", name: "Poland", callingCode: "48", phoneMin: 9, phoneMax: 9 },
  { code: "PT", name: "Portugal", callingCode: "351", phoneMin: 9, phoneMax: 9 },
  { code: "PR", name: "Puerto Rico", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "QA", name: "Qatar", callingCode: "974", phoneMin: 8, phoneMax: 8 },
  { code: "RE", name: "Réunion", callingCode: "262", phoneMin: 9, phoneMax: 9 },
  { code: "RO", name: "Romania", callingCode: "40", phoneMin: 9, phoneMax: 9 },
  { code: "RU", name: "Russia", callingCode: "7", phoneMin: 10, phoneMax: 10 },
  { code: "RW", name: "Rwanda", callingCode: "250", phoneMin: 9, phoneMax: 9 },
  { code: "KN", name: "Saint Kitts and Nevis", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "LC", name: "Saint Lucia", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "VC", name: "Saint Vincent and the Grenadines", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "WS", name: "Samoa", callingCode: "685", phoneMin: 5, phoneMax: 7 },
  { code: "SM", name: "San Marino", callingCode: "378", phoneMin: 6, phoneMax: 10 },
  { code: "ST", name: "São Tomé and Príncipe", callingCode: "239", phoneMin: 7, phoneMax: 7 },
  { code: "SA", name: "Saudi Arabia", callingCode: "966", phoneMin: 9, phoneMax: 9 },
  { code: "SN", name: "Senegal", callingCode: "221", phoneMin: 9, phoneMax: 9 },
  { code: "RS", name: "Serbia", callingCode: "381", phoneMin: 8, phoneMax: 12 },
  { code: "SC", name: "Seychelles", callingCode: "248", phoneMin: 7, phoneMax: 7 },
  { code: "SL", name: "Sierra Leone", callingCode: "232", phoneMin: 8, phoneMax: 8 },
  { code: "SG", name: "Singapore", callingCode: "65", phoneMin: 8, phoneMax: 8 },
  { code: "SK", name: "Slovakia", callingCode: "421", phoneMin: 9, phoneMax: 9 },
  { code: "SI", name: "Slovenia", callingCode: "386", phoneMin: 8, phoneMax: 8 },
  { code: "SB", name: "Solomon Islands", callingCode: "677", phoneMin: 5, phoneMax: 5 },
  { code: "SO", name: "Somalia", callingCode: "252", phoneMin: 7, phoneMax: 8 },
  { code: "ZA", name: "South Africa", callingCode: "27", phoneMin: 9, phoneMax: 9 },
  { code: "KR", name: "South Korea", callingCode: "82", phoneMin: 9, phoneMax: 10 },
  { code: "ES", name: "Spain", callingCode: "34", phoneMin: 9, phoneMax: 9 },
  { code: "LK", name: "Sri Lanka", callingCode: "94", phoneMin: 9, phoneMax: 9 },
  { code: "SD", name: "Sudan", callingCode: "249", phoneMin: 9, phoneMax: 9 },
  { code: "SR", name: "Suriname", callingCode: "597", phoneMin: 6, phoneMax: 7 },
  { code: "SE", name: "Sweden", callingCode: "46", phoneMin: 7, phoneMax: 10 },
  { code: "CH", name: "Switzerland", callingCode: "41", phoneMin: 9, phoneMax: 9 },
  { code: "SY", name: "Syria", callingCode: "963", phoneMin: 8, phoneMax: 10 },
  { code: "TW", name: "Taiwan", callingCode: "886", phoneMin: 9, phoneMax: 9 },
  { code: "TJ", name: "Tajikistan", callingCode: "992", phoneMin: 9, phoneMax: 9 },
  { code: "TZ", name: "Tanzania", callingCode: "255", phoneMin: 9, phoneMax: 9 },
  { code: "TH", name: "Thailand", callingCode: "66", phoneMin: 8, phoneMax: 9 },
  { code: "TL", name: "Timor-Leste", callingCode: "670", phoneMin: 7, phoneMax: 8 },
  { code: "TG", name: "Togo", callingCode: "228", phoneMin: 8, phoneMax: 8 },
  { code: "TO", name: "Tonga", callingCode: "676", phoneMin: 5, phoneMax: 7 },
  { code: "TT", name: "Trinidad and Tobago", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "TN", name: "Tunisia", callingCode: "216", phoneMin: 8, phoneMax: 8 },
  { code: "TR", name: "Turkey", callingCode: "90", phoneMin: 10, phoneMax: 10 },
  { code: "TM", name: "Turkmenistan", callingCode: "993", phoneMin: 8, phoneMax: 8 },
  { code: "TC", name: "Turks and Caicos Islands", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "TV", name: "Tuvalu", callingCode: "688", phoneMin: 5, phoneMax: 6 },
  { code: "UG", name: "Uganda", callingCode: "256", phoneMin: 9, phoneMax: 9 },
  { code: "UA", name: "Ukraine", callingCode: "380", phoneMin: 9, phoneMax: 9 },
  { code: "AE", name: "United Arab Emirates", callingCode: "971", phoneMin: 8, phoneMax: 9 },
  { code: "UY", name: "Uruguay", callingCode: "598", phoneMin: 8, phoneMax: 8 },
  { code: "UZ", name: "Uzbekistan", callingCode: "998", phoneMin: 9, phoneMax: 9 },
  { code: "VU", name: "Vanuatu", callingCode: "678", phoneMin: 5, phoneMax: 7 },
  { code: "VA", name: "Vatican City", callingCode: "39", phoneMin: 9, phoneMax: 11 },
  { code: "VE", name: "Venezuela", callingCode: "58", phoneMin: 10, phoneMax: 10 },
  { code: "VN", name: "Vietnam", callingCode: "84", phoneMin: 9, phoneMax: 10 },
  { code: "VG", name: "Virgin Islands (British)", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "VI", name: "Virgin Islands (U.S.)", callingCode: "1", phoneMin: 10, phoneMax: 10 },
  { code: "YE", name: "Yemen", callingCode: "967", phoneMin: 7, phoneMax: 9 },
  { code: "ZM", name: "Zambia", callingCode: "260", phoneMin: 9, phoneMax: 9 },
  { code: "ZW", name: "Zimbabwe", callingCode: "263", phoneMin: 5, phoneMax: 10 },
];

export interface UsState {
  code: string;
  name: string;
}

export const US_STATES: UsState[] = [
  { code: "AL", name: "Alabama" },
  { code: "AK", name: "Alaska" },
  { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" },
  { code: "CA", name: "California" },
  { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" },
  { code: "DE", name: "Delaware" },
  { code: "DC", name: "District of Columbia" },
  { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" },
  { code: "HI", name: "Hawaii" },
  { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" },
  { code: "IN", name: "Indiana" },
  { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" },
  { code: "KY", name: "Kentucky" },
  { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" },
  { code: "MD", name: "Maryland" },
  { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" },
  { code: "MN", name: "Minnesota" },
  { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" },
  { code: "MT", name: "Montana" },
  { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" },
  { code: "NH", name: "New Hampshire" },
  { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" },
  { code: "NY", name: "New York" },
  { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" },
  { code: "OH", name: "Ohio" },
  { code: "OK", name: "Oklahoma" },
  { code: "OR", name: "Oregon" },
  { code: "PA", name: "Pennsylvania" },
  { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" },
  { code: "SD", name: "South Dakota" },
  { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" },
  { code: "UT", name: "Utah" },
  { code: "VT", name: "Vermont" },
  { code: "VA", name: "Virginia" },
  { code: "WA", name: "Washington" },
  { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" },
  { code: "WY", name: "Wyoming" },
];

export function findCountryByName(name: string): Country | null {
  if (!name) return null;
  const needle = name.trim().toLowerCase();
  return (
    COUNTRIES.find((c) => c.name.toLowerCase() === needle) ??
    COUNTRIES.find((c) => c.code.toLowerCase() === needle) ??
    null
  );
}

export function findUsStateByName(name: string): UsState | null {
  if (!name) return null;
  const needle = name.trim().toLowerCase();
  return (
    US_STATES.find((s) => s.name.toLowerCase() === needle) ??
    US_STATES.find((s) => s.code.toLowerCase() === needle) ??
    null
  );
}

export function isUsCountry(country: Country | null): boolean {
  return country?.code === "US";
}

/**
 * Validate a phone number for the given country.
 *
 * Accepts an optional leading "+" and ignores spaces, dashes, parentheses.
 * If the number starts with the country's calling code, it is stripped before
 * length validation. Returns null if valid, or an error message.
 */
export function validatePhone(
  phone: string,
  country: Country | null,
): string | null {
  const trimmed = phone.trim();
  if (!trimmed) return "Phone is required";

  const hasPlus = trimmed.startsWith("+");
  const digits = trimmed.replace(/\D/g, "");
  if (!digits) return "Phone must contain digits";

  if (!country) {
    if (digits.length < 7 || digits.length > 15) {
      return "Phone number length looks invalid";
    }
    return null;
  }

  let national = digits;
  if (hasPlus && digits.startsWith(country.callingCode)) {
    national = digits.slice(country.callingCode.length);
  } else if (!hasPlus && digits.startsWith(country.callingCode) && digits.length > country.phoneMax) {
    national = digits.slice(country.callingCode.length);
  }

  if (national.length < country.phoneMin || national.length > country.phoneMax) {
    const range =
      country.phoneMin === country.phoneMax
        ? `${country.phoneMin} digits`
        : `${country.phoneMin}–${country.phoneMax} digits`;
    return `${country.name} phone must be ${range}`;
  }

  return null;
}
